import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-importing-selections-modal',
  templateUrl: './importing-selections-modal.component.html',
  styleUrls: ['./importing-selections-modal.component.scss']
})
export class ImportingSelectionsModalComponent implements OnInit {

  loadingProgress = 40;  //this will need to be linked to the loading progress in the api

  constructor(public dialogRef: MatDialogRef<ImportingSelectionsModalComponent>) { }

  ngOnInit() {
  }

  onClose(): void {
    this.dialogRef.close();
  }

}
